<style scoped>
.this__lock {
  position: absolute;
  z-index: 2;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
</style>
<template>
  <div class="demo__AuthLockBlock demo__relative demo__pointer">
    <slot></slot>
    <div class="this__lock" @click="openAuthModal" v-if="!user"></div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters(["user"]),
  },
  props: {
    ym_location: {
      required: false,
      type: String,
      default: undefined,
    },
    modalStatus: {
      type: String,
      required: false,
      default: "Login",
    },
    ymParams: {
      type: Object,
      required: false,
      default: () => {},
    },
  },
  methods: {
    openAuthModal() {
      this.$store.dispatch("updateAuthModalStatus", this.modalStatus);
      if (this.ym_location || this.ymParams) {
        const signUpFrom = this.ym_location
          ? { signUpFrom: this.ym_location }
          : {};
        const data = {
          step: 0,
          ...signUpFrom,
          ...this.ymParams,
        };
        this.$root.$emit("reachGoal", {
          goalName: "signup",
          data: data,
        });
        this.$debug(
          "YA METRICS: событие signup from " +
            (this.ym_location || "не указано"),
          "ya_metric",
          {
            ym_location: this.ym_location,
            modalStatus: this.modalStatus,
            data,
          }
        );
      }
    },
  },
};
</script>
